/* eslint-disable consistent-return */
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  getConfiguracoesDeletaInstancia,
  getConfiguracoesGetInstancia,
} from '../../services/Configuracoes/getConfiguracoes'

// `ativo` indica se o painel de WhatsApp está aberto; só então buscamos e
// fazemos polling da instância (antes o polling rodava sempre, mesmo fechado).
export const useConfiguracoes = (ativo: boolean) => {
  const [isLoading, setIsLoading] = useState(false)
  const [desconectarInstancia, setDesconectarInstancia] = useState(false)
  const [instancia, setInstancia] = useState<GetConfiguracoesInstacia>(
    {} as GetConfiguracoesInstacia
  )

  const fetchGetInstancia = async () => {
    setIsLoading(true)
    const result = await getConfiguracoesGetInstancia()
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setInstancia(result)
    }
  }
  const fetchDeletaInstancia = async () => {
    setIsLoading(true)
    const result = await getConfiguracoesDeletaInstancia()
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      toast.success(result.sucesso)
      fetchGetInstancia()
    }
  }

  const handleDeletaInstancia = () => {
    setDesconectarInstancia(true)
  }

  const fechaDesconectarInstancia = () => setDesconectarInstancia(false)
  const desconectar = () => fetchDeletaInstancia()

  useEffect(() => {
    if (!ativo) return
    fetchGetInstancia()
    const timer = setInterval(fetchGetInstancia, 15000)
    return () => clearInterval(timer)
  }, [ativo])

  return {
    handleDeletaInstancia,
    isLoading,
    instancia,
    desconectarInstancia,
    setDesconectarInstancia,
    fechaDesconectarInstancia,
    desconectar,
  }
}
